import Reflux from 'reflux';

export default Reflux.createActions([
	'sync',
	'changeSource',
	'selectStand',
	'search',
]);
